import React, { KeyboardEventHandler, useCallback, useRef } from 'react';
import { TextInput } from 'src/common/form/text-input';
import { Organization } from 'src/common/interfaces/organization.interface';
import { JourneyMenu } from 'src/common/JourneyMenu';
import { useNotificationMessage } from 'src/common/notification/message.hook';
import { useCurrentOrganization } from 'src/store/organization';
import { useCurrentUser } from 'src/store/user';
import { Nullable } from 'src/types/nullable.type';
import { apiSwitchOrganization, apiSwitchOrganizationBySlug } from 'src/utils/journeyApi';
import ManagementDropdownList from './list';

const AdminOrganizationSwitcher = () => {
  const currentUser = useCurrentUser((state) => state.currentUser);
  const inputElementRef = useRef<Nullable<HTMLInputElement>>(null);
  const { setErrorNotification } = useNotificationMessage();

  const switchOrg = useCallback(
    (value) => {
      apiSwitchOrganizationBySlug(value)
        .then(() => {
          window.location.replace('/');
        })
        .catch((err) => {
          setErrorNotification(err.message);
        });
    },
    [setErrorNotification]
  );

  const handleKeyDown: KeyboardEventHandler<HTMLInputElement> = (e) => {
    e.stopPropagation();
    const { value } = e.currentTarget;
    if (e.key === 'Enter' && value.length > 0) {
      switchOrg(value);
      return;
    }
  };

  if (!currentUser?.is_admin) return null;

  return (
    <TextInput
      id='admin-org-switcher'
      ref={inputElementRef}
      inputProps={{
        placeholder: 'Allow Gandalf to conjure another organization',
      }}
      onKeyDown={handleKeyDown}
    />
  );
};

export default AdminOrganizationSwitcher;
